import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import { academylist } from "../../../services/admin";
import { useLocation } from "react-router-dom";
import { incexpcreate, incexpdelete, incexpdetail, incexplist, incexpupdate, incexpvalidate } from "../../../services/master";
export const IncExpHead = () => {
    const [filterProduct, setFilterProduct] = useState([]);
    const [Catid, setID] = useState(0);
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");


    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [errorMessage, setErrorMessage] = useState("");

    const location = useLocation();
    const [urllink, setUrllink] = useState("");

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        funlist(path);
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
    }, [location.pathname]);

    function funlist(ltype) {
        setFilterProduct([]);
        const temp = new FormData();
        if (ltype === "addincomehead") {
            temp.append("type", 1);
        } else if (ltype === "addexpensehead") {
            temp.append("type", 2);
        } else {
            temp.append("type", 0);
        }
        incexplist(temp).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }
    const columnDefs = [
        {
            headerName: "Income Head",
            width: 170,
            field: "head_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Description",
            width: 170,
            field: "description",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            width: 300,
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            width: 150,
            field: "active",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            width: 180,
            field: "id",
            resizable: true,
            filter: false,
            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnEDefs = [
        {
            headerName: "Expense Head",
            width: 170,
            field: "head_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Description",
            width: 170,
            field: "description",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            width: 300,
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            width: 150,
            field: "active",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            width: 180,
            field: "id",
            resizable: true,
            filter: false,
            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnWDefs = [
        {
            headerName: "Income Head",
            width: 370,
            field: "head_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Description",
            width: 300,
            field: "description",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            width: 150,
            field: "active",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            width: 180,
            field: "id",
            resizable: true,
            filter: false,
            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    const columnEWDefs = [
        {
            headerName: "Expense Head",
            width: 370,
            field: "head_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Description",
            width: 300,
            field: "description",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Status",
            width: 150,
            field: "active",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value === 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            width: 180,
            field: "id",
            resizable: true,
            filter: false,
            // headerClass: "ag-center-aligned-header",
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewshow(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    function handleSwitch(list) {
        if (list.value === 1) {
            Swal.fire({
                text: "Are you sure want to Inactive?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#ac0404",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Inactive",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", list.data.id);
                    temp.append("status", 0);

                    incexpdelete(temp).then((response) => {
                        if (response.status === true) {
                            funlist(urllink);
                        }
                    });
                }
            });
        } else {
            Swal.fire({
                text: "Are you sure want to Active?",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#008000",
                cancelButtonColor: "#6259ca",
                confirmButtonText: "Active",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const temp = new FormData();
                    temp.append("id", list.data.id);
                    temp.append("status", 1);

                    incexpdelete(temp).then((response) => {
                        if (response.status === true) {
                            funlist(urllink);
                        }
                    });
                }
            });
        }
    }

    const [show, setShow] = useState(false);
    function handleshow() {
        setID(0);
        setName("");
        setDesc("");
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    if (arr.length > 0) {
                      setAcaID(arr[0]);
                    }
                  }
                 
                }
              }
            });
          }
        setErrorMessage("");
        setShow(true);
    }

    function handleclose() {
        setID(0);
        setAcaID("");
        setErrorMessage("");
        setShow(false);
    }

    function viewshow(vid) {
        setID(vid);
        setName("");
        setDesc("");
        setShow(true);

        setErrorMessage("");
        incexpdetail(vid).then((response) => {
            if (response.status === true) {
                setName(response.data.head_name);
                setDesc(response.data.description);
                academylist().then((res) => {
                    if (res.status === true) {
                        let arr = [];
                        if (res.data.details.length > 0) {
                            for (let i = 0; i < res.data.details.length; i++) {
                                if (res.data.details[i].id === response.data.academy_id) {
                                    arr.push({
                                        value: res.data.details[i].id,
                                        label:
                                            res.data.details[i].name + " - " + res.data.details[i].code,
                                    });
                                }
                            }
                            setAcaID(arr[0]);
                        }
                    }
                });
            }
        });
    }



    function Submitage() {
        setErrorMessage("");
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrorMessage("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }
        if (valid === "") {
            if (name !== "") {
                const temp = new FormData();
                temp.append("name", name);
                temp.append("id", Catid);
                if (urllink === "addincomehead") {
                    temp.append("type", 1);
                } else if (urllink === "addexpensehead") {
                    temp.append("type", 2);
                } else {
                    temp.append("type", 0);
                }
                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                    temp.append("academy_id", acaid.value);
                }
                incexpvalidate(temp).then((response) => {
                    if (response.status === false) {
                        setErrorMessage(response.message);
                    } else {
                        const tempData = new FormData();
                        tempData.append("name", name);
                        tempData.append("desc", desc);
                        if (urllink === "addincomehead") {
                            tempData.append("type", 1);
                        } else if (urllink === "addexpensehead") {
                            tempData.append("type", 2);
                        } else {
                            tempData.append("type", 0);
                        }
                        tempData.append("user_id", localStorage.getItem("UID"));
                        if (localStorage.getItem("Role") === "1" && acaid !== "") {
                            tempData.append("academy_id", acaid.value);
                        }
                        if (Catid === 0) {
                            incexpcreate(tempData).then((response) => {
                                if (response.status === true) {
                                    handleclose();
                                    funlist(urllink);
                                    toast.success(response.message);
                                } else {
                                    setErrorMessage(response.data.message);
                                }
                            });
                        } else {
                            tempData.append("id", Catid);
                            incexpupdate(tempData).then((response) => {
                                if (response.status === true) {
                                    handleclose();
                                    funlist(urllink);
                                    toast.success(response.message);
                                } else {
                                    setErrorMessage(response.data.message);
                                }
                            });
                        }
                    }
                });
            } else {
                if (urllink === "addincomehead") {
                    setErrorMessage("Please Enter Income Head");
                } else if (urllink === "addexpensehead") {
                    setErrorMessage("Please Enter Expense Head");
                }
            }
        }

    }

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
        } else {
            setAcaID("");
        }
    }

    return (
        <Fragment>
            <div className="page-header reported-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">{urllink === "addincomehead" ? "Add Income Head" : "Add Expense Head"}</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Income and Expense</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {urllink === "addincomehead" ? "Add Income Head" : "Add Expense Head"}
                        </li>
                    </ol>
                </div>
            </div>
            <Row className="row-sm mx-0 mt-3">
                <Col xxl={12} lg={12} md={12}>
                    <Card className="custom-card overflow-hidden">
                        <Card.Body>
                            <div className="responsive">
                                <div className="res-right">
                                    <a
                                        onClick={handleshow}
                                        variant="success"
                                        type="button"
                                        className="btn my-1 me-2 btn-success tx-teko"
                                    >
                                        {" "}
                                        Add
                                    </a>
                                </div>
                                {urllink === "addincomehead" &&
                                    <div className="ag-theme-alpine ag-style">
                                        <AgGridReact
                                            columnDefs={localStorage.getItem("Role") === "1" ? columnDefs : columnWDefs}
                                            rowData={filterProduct}
                                            pagination="true"
                                            paginationPageSize="10"
                                            sortingOrder={["asc", "desc"]}
                                            suppressDragLeaveHidesColumns={true}
                                        />
                                    </div>
                                }
                                {urllink === "addexpensehead" &&
                                    <div className="ag-theme-alpine ag-style">
                                        <AgGridReact
                                            columnDefs={localStorage.getItem("Role") === "1" ? columnEDefs : columnEWDefs}
                                            rowData={filterProduct}
                                            pagination="true"
                                            paginationPageSize="10"
                                            sortingOrder={["asc", "desc"]}
                                            suppressDragLeaveHidesColumns={true}
                                        />
                                    </div>
                                }

                            </div>

                            <Modal show={show}>
                                <Modal.Header>
                                    {urllink === "addincomehead" && Catid === 0 ?
                                        <h4>Add Income Head</h4> :
                                        urllink === "addexpensehead" && Catid === 0 ?
                                            <h4>Add Expense Head</h4> :
                                            urllink === "addincomehead" && Catid !== 0 ?
                                                <h4>Income Head Detail</h4> :
                                                urllink === "addexpensehead" && Catid !== 0 &&
                                                <h4>Expense Head Detail</h4>
                                    }

                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        {localStorage.getItem("Role") === "1" && (
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Academy
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={alist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        )}

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    {urllink === "addincomehead" ? "Income Head" : "Expense Head"} <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    placeholder={urllink === "addincomehead" ? "Enter Income Head" : "Enter Expense Head"}
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Description
                                                </label>
                                            </div>
                                            <div className="form-group">
                                                <textarea
                                                    rows="3"
                                                    placeholder="Enter Description"
                                                    value={desc}
                                                    onChange={(e) => setDesc(e.target.value)}
                                                />
                                            </div>
                                        </Col>

                                        {errorMessage !== "" && (
                                            <span className="text-danger">{errorMessage}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    {Catid === 0 ? (
                                        <a
                                            onClick={Submitage}
                                            className="btn btn-next btn-success"
                                            style={{ float: "right" }}
                                        >
                                            Submit
                                        </a>
                                    ) : (
                                        <a
                                            onClick={Submitage}
                                            className="btn btn-next btn-success"
                                            style={{ float: "right" }}
                                        >
                                            Update
                                        </a>
                                    )}
                                    <a
                                        className="btn btn-next btn-secondary"
                                        style={{ float: "right" }}
                                        onClick={handleclose}
                                    >
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};
